import { Component, OnInit, OnDestroy } from '@angular/core';

import { Router } from '@angular/router';

import { AuthService } from '../../service/auth.service';
import { UserProfileService } from '../../service/user-profile.service';
import { CommonService } from '../../service/common.service';

@Component({
  selector: 'app-user-welcome',
  templateUrl: './user-welcome.component.html',
  styleUrls: ['./user-welcome.component.css']
})
export class UserWelcomeComponent implements OnInit, OnDestroy {
  uid: string;

  constructor(
    private userProfileService: UserProfileService,
    public authService: AuthService,
    private router: Router,
    private commonService: CommonService) {
      this.commonService.isUserWelcomeTopBG = true;
    }

  ngOnInit() {
    this.uid = this.authService.getCurrentUser() ? this.authService.getCurrentUser().uid : '';
  }

  ngOnDestroy() {
    this.commonService.isUserWelcomeTopBG = false;
  }

  recordAck() {
    this.userProfileService.userAckWelcome(this.uid)
    .then(res => {
      this.router.navigate(['/']);
    });
  }

}
